import { AlertIcon, CheckOutlinedIcon, CloseCircleIcon, GiftIcon, Spinner } from "@tutellus/tutellus-components"
import { Transaction, TransactionStatus, TransactionType } from "../../../domain/ethereum/Models/Transaction"

const STATUS_ICONS: Record<TransactionStatus, React.JSX.Element> = {
  [Transaction.STATUS.PENDING]: <Spinner />,
  [Transaction.STATUS.SUCCESS]: <CheckOutlinedIcon />,
  [Transaction.STATUS.REVERTED]: <CloseCircleIcon />,
  [Transaction.STATUS.EXPIRED]: <AlertIcon />,
}

export const getStatusIcon = (status: TransactionStatus) => {
  return STATUS_ICONS[status]
}

const TRANSACTION_ICONS: Record<TransactionType, React.JSX.Element> = {
  [Transaction.TYPES.MINT_POAP]: <GiftIcon />,
}

export const getTypeIcon = (type: TransactionType) => {
  return TRANSACTION_ICONS[type]
}
